document.addEventListener('DOMContentLoaded', () => {
    let parent, span_node, bold_node, text, cell_content;

    document.querySelectorAll("body:not(.admin_namespace.admin_admin_users) a[href^='/admin/admin_users/']").forEach(function (link_node) {
        parent = link_node.parentNode;
        bold_node = document.createElement("b");
        span_node = document.createElement("span");
        text = document.createTextNode(link_node.innerHTML);
        span_node.appendChild(text);
        bold_node.appendChild(span_node);
        parent.insertBefore(bold_node, link_node);
        parent.removeChild(link_node);
    });

    document.querySelectorAll("tr.row[class$='status'] td, td.col[class$='status']").forEach(function (cell_node) {
        cell_content = cell_node.innerHTML.trim();

        if (cell_content !== '<span class="empty">Empty</span>' && cell_content.substring(0, 23) !== '<span class="status_tag') {
            text = document.createTextNode(cell_content);
            bold_node = document.createElement("b");
            bold_node.appendChild(text);
            cell_node.innerHTML = '';
            cell_node.appendChild(bold_node);
        }
    });
});
